import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("../components/home.vue"),
    },
    {
      path: "/one",
      name: "one",
      component: () => import("../components/one.vue"),
    },
    {
      path: "/two",
      name: "two",
      component: () => import("../components/two.vue"),
    },
    {
      path: "/three",
      name: "three",
      component: () => import("../components/three.vue"),
    },
    {
      path: "/four",
      name: "four",
      component: () => import("../components/four.vue"),
    },
    {
      path: "/five",
      name: "five",
      component: () => import("../components/five.vue"),
    },
    {
      path: "/six",
      name: "six",
      component: () => import("../components/six.vue"),
    },
    {
      path: "/seven",
      name: "seven",
      component: () => import("../components/seven.vue"),
    },
    {
      path: "/ceshi",
      name: "ceshi",
      component: () => import("../components/ceshi.vue"),
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js